module.exports = __webpack_public_path__ + "img/emoji_11.fba7a00e.png";